<template>
    <v-container fluid class="main-body">
        <r-header></r-header>
        <HeaderPanel></HeaderPanel>
        <v-skeleton-loader
                v-if="!isVisible"
                ref="rosconForm"
                type="article"
                class="mx-auto"
        ></v-skeleton-loader>
        <v-form ref="formInfantil" id="roscon" v-if="isVisible" lazy-validation>
            <!-- NOMBRE, APELLIDOS, FNAC -->
            <v-row>
                <v-col cols="12" sm="6" md="4" >
                    <v-text-field
                            prepend-icon="face"
                            v-model.trim="persona.nombre"
                            required
                            :rules="rules.nombre"
                    >
                        <template v-slot:label>
                            Nombre<sup>
                            *
                        </sup>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <v-text-field
                            prepend-icon="face"
                            v-model.trim="persona.apellidos"
                            required
                            :rules="rules.apellidos"
                    >
                        <template v-slot:label>
                            Apellidos<sup>
                            *
                        </sup>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <datePicker
                            @change="cambiaEdad"
                            v-model.trim="persona.fnac"
                            :current="currentDate"
                            minDate="2007-01-01"
                            v-if="viewDate"
                            required
                    >
                        <template v-slot:append-outer>
                            <v-icon small color="primary">info</v-icon>
                        </template>
                    </datePicker>
                </v-col>
            </v-row>

            <!-- GENERO, LOCALIDAD, CATEGORIA -->
            <v-row>
                <v-col cols="12" sm="6" md="4" >
                    <v-radio-group row label="Genero"
                                   v-model="persona.sexo"
                                   required
                                   :rules="rules.sexo"
                                   @change="cambiaSexo"
                    >
                        <v-radio label="Niño" value="V"
                        ></v-radio>
                        <v-radio label="Niña" value="F"
                        ></v-radio>
                        <template v-slot:label>
                            Genero<sup>
                            *
                        </sup>
                        </template>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <v-text-field
                            prepend-icon="location_city"
                            v-model.trim="persona.localidad"
                            required
                            :rules="rules.localidad"
                    >
                        <template v-slot:label>
                            Localidad de residencia<sup>
                            *
                        </sup>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <v-select
                            :items="categorias"
                            prepend-icon="group_work"
                            label="Categoría"
                            v-model="persona.idCategoria"
                            item-text="nombre"
                            item-value="id"
                            :item-disabled="(item) => item.limite < 1"
                            readonly
                    ></v-select>
                </v-col>
            </v-row>

            <!-- FEDERADO, LICENCIA, CLUB -->
            <v-row>
                <v-col cols="12" sm="6" md="4" >
                    <v-radio-group row
                                   v-model.trim="persona.federado"
                                   required
                                   :rules="rules.federado"
                                   @change="cambiaFederado"
                    >
                        <template v-slot:label>
                            Federado en atletismo<sup>
                            *
                        </sup>
                        </template>
                        <v-radio label="SI" value="SI"
                        ></v-radio>
                        <v-radio label="NO" value="NO"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <v-text-field
                            label="Nº de Licencia Atletismo"
                            prepend-icon="credit_card"
                            placeholder="Obligatorio para atletas federados"
                            v-model="persona.licencia"
                            :required="persona.federado === 'SI'"
                            :rules="rules.licencia"
                            :disabled="persona.federado === 'NO' || persona.federado === ''"

                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                            label="Club"
                            prepend-icon="group"
                            v-model="persona.club"
                    ></v-text-field>
                </v-col>
            </v-row>

            <!-- DATOS DEL TUTOR -->
            <v-banner transition="slide-y-transition" elevation="4" color="blue lighten-1">
                <v-row>
                    <v-col cols="12">
                        <h2 class="text-center">Datos del padre, madre o tutor</h2><br>
                        <p>Por ser menor de 18 años se debe facilitar los datos de una persona mayor de edad que actuará
                            como tutor y se responsabilizará de que el menor esté capacitado para participar en la
                            carrera.</p>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                prepend-icon="face"
                                v-model.trim="persona.nombre_tutor"
                                required
                                :rules="rules.nombre_tutor"

                        >
                            <template v-slot:label>
                                Nombre y apellidos del tutor<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                label="DNI del tutor"
                                prepend-icon="fingerprint"
                                v-model.trim="persona.dni_tutor"
                                required
                                :rules="rules.dni_tutor"
                                maxlength="9"
                        >
                            <template v-slot:label>
                                DNI del tutor<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                prepend-icon="email"
                                v-model.trim="persona.email_tutor"
                                required
                                :rules="rules.email_tutor"
                        >
                            <template v-slot:label>
                                Correo electrónico<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" >
                        <v-text-field
                                label="Teléfono de contacto"
                                prepend-icon="phone"
                                v-model.trim="persona.tlfno_tutor"
                                required
                                :rules="rules.tlfno_tutor"
                                maxlength="9"
                        >
                            <template v-slot:label>
                                Teléfono de contacto<sup>
                                *
                            </sup>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-banner>

            <!-- CAMISETA, TALLA, DUCHAS -->
            <v-row>
                <v-col cols="12" sm="6" md="2" >
                    <v-radio-group row
                                   v-model="persona.camiseta"
                    >
                        <template v-slot:label>
                            Quiero camiseta<sup>*</sup>
                        </template>
                        <v-radio label="SI" value="SI"></v-radio>
                        <v-radio label="NO" value="NO" disabled></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="3" >
                    <v-select
                            :items="tallas"
                            prepend-icon="list"
                            label="Talla de la camiseta"
                            :disabled="(persona.camiseta === 'NO' || persona.camiseta === '')"
                            v-model="persona.talla"
                            required
                            :rules="rules.talla"

                    >
                        <template v-slot:label>
                            Talla de la camiseta <sup>*</sup>
                        </template>
                        <template v-slot:append-outer>
                            <v-dialog v-model="infoTallas" persistent max-width="600px">
                                <template v-slot:activator="{ on }">
                                    <v-icon small color="primary" v-on="on">info</v-icon>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Tallas según disponibilidad</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-img src="@/assets/tallas_camisetas.jpg"
                                                           lazy-src="@/assets/tallas_camisetas.jpg"
                                                    ></v-img>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="infoTallas = false">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                            label="Apodo"
                            prepend-icon="label"
                            v-model="persona.apodo"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <v-radio-group row
                                   v-model.trim="persona.ducha"
                                   required
                                   :rules="rules.ducha"
                    >
                        <template v-slot:label>
                            Uso de servicio de DUCHAS en CDM Siglo XXI<sup>
                            *
                        </sup>
                        </template>
                        <v-radio label="SI" value="SI"
                        ></v-radio>
                        <v-radio label="NO" value="NO"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <!-- TIENDA, ESTADO, DORSAL -->
            <v-row>
                <v-col cols="12" sm="6" md="4" >
                    <v-select
                            :items="tiendas"
                            prepend-icon="storefront"
                            label="Tienda"
                            v-model.trim="persona.idTienda"
                            item-text="nombre"
                            item-value="id"
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4" >
                    <v-select
                            :items="estados"
                            prepend-icon="sort"
                            label="Estado de la inscripción"
                            v-model.trim="persona.idEstado"
                            item-text="nombre"
                            item-value="id"
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                            label="Dorsal"
                            prepend-icon="money"
                            v-model="persona.dorsal"
                    ></v-text-field>
                </v-col>
            </v-row>

            <!-- OBSERVACIONES -->
            <v-banner elevation="2" single-line icon="info" icon-color="blue lighten-1" >
                <v-row style="width: 75%; ">
                    <v-col cols="12">
                        Precio único: 7 €
                    </v-col>
                </v-row>
            </v-banner>

            <!-- BOTONES -->
            <v-row>
                <v-col cols="6">
                    <v-btn block large color="success darken-3" @click="actualizar">Guardar cambios</v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn block large color="info lighten-1"  :to="{name: 'panel'}">
                        Volver al listado
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                            name="observaciones"
                            label="Observaciones"
                            v-model="persona.observaciones"
                    ></v-textarea>
                </v-col>
            </v-row>
        </v-form>
        <v-dialog v-model="resultado" persistent max-width="600px">
            <template v-slot:activator="{ on }">

            </template>
            <v-card>
                <v-card-title>
                    <span class="headline myModal">Actualización de datos realizada</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <h4>Los datos para este corredor se han actualizado</h4>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text to="/panel">Volver al listado</v-btn>
                    <v-btn color="blue darken-1" text @click="resultado = false">Seguir editando</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import DatepickerComponent from "@/components/shared/DatepickerComponent"
    import {cat, tallas, tiendas} from '@/config'
    import moment from "moment";
    import HeaderPanel from "../../components/shared/HeaderPanel";
    import {cookiesHelper} from "../../_helpers";
    import {panelService} from "../../_services/panel";
    import RHeader from "../../components/shared/HeaderComponent";
    export default {
        name: "Editar",
        props: ['carrera', 'id'],
        data() {
            return {
                isValid: true,
                isVisible: false,
                isMenor: false,
                infoTallas: false,
                infoMarca: false,
                infoCategoria: false,
                viewDate: true,
                resultado:false,
                currentDate: null,
                categorias: [],
                catTemp: null,
                tallas: [],
                tiendas: [],
                estados: [
                    { id:"5", nombre:'Inscrito' },
                    { id:"4", nombre:'Invitado' },
                ],
                diaCarrera: moment('2020-01-29'),
                persona: {
                    id:'',
                    dorsal:'',
                    nombre: '',
                    apellidos: '',
                    fnac: '',
                    localidad: '',
                    sexo: 'V',
                    nombre_tutor: '',
                    dni_tutor: '',
                    email_tutor: '',
                    tlfno_tutor: '',
                    idCategoria: '',
                    idCarrera: 3,
                    idTienda: '',
                    idEstado:'',
                    federado: '',
                    licencia: '',
                    club: '',
                    apodo: '',
                    camiseta: 'SI',
                    talla: '',
                    ducha:'',
                    observaciones: '',

                },
                token: '',
                rules: {
                    nombre: [
                        v => !!v || 'El nombre es necesario',
                        v => (v && v.length >= 3) || 'El nombre debe de tener 3 caracteres o mas.'
                    ],
                    apellidos:[
                        v => !!v || 'Los apellidos son necesarios',
                        v => (v && v.length >= 3) || 'Los apellidos deben de tener 3 caracteres o mas.'
                    ],
                    localidad: [
                        v => !!v || 'La localidad de residencia la necesitamos',
                        v => (v && v.length >= 3) || 'Debe de tener 3 caracteres o mas.'
                    ],
                    federado: [
                        v => !!v || 'Esta información necesitamos saberla',
                    ],
                    licencia: [
                        v => {  if(this.persona.federado === "SI") return !!v || 'Debe de ser un número de liciencia valido'; else return !!v}
                    ],
                    sexo: [
                        v => !!v || 'Es necesario para poder continuar',
                    ],
                    nombre_tutor: [
                        v => !!v || 'El nombre es necesario',
                        v => (v && v.length >= 10) || 'El nombre debe de tener 10 caracteres o mas.'
                    ],
                    dni_tutor: [
                        v => !!v || 'El dni es necesario',
                        v => /(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))/.test(v) ||
                            "El formato no es correcto (ej. 12345678A)"
                    ],
                    email_tutor: [
                        v => !!v || 'El email es necesario para poder contactar',
                        v => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(v)
                            || 'El email no tiene el formato correcto'
                    ],
                    tlfno_tutor: [
                        v => !!v || 'Es necesario por si necesitamos contactar',
                        v => /^\d+$/.test(v) || 'Solo se aceptan números',
                        v => (v && v.length == 9) || 'Debe de tener 9 numeros sin espacios.'
                    ],
                    talla: [
                        //v => !!v || 'Necesitamos saber la talla de la camiseta' ,
                        v => {  if(this.persona.camiseta === "SI") return !!v || 'Necesitamos saber la talla de la camiseta'; else return !!v}
                    ],
                    ducha: [
                        v => !!v || 'Necesitamos saber si vas a usar el servicio de duchas o no'
                    ],
                    condiciones: [
                        v => !!v || 'Tienes que leer y aceptar las condiciones de la carrera',
                    ]
                }
            }
        },
        created() {
            this.categorias = cat.infantiles
            this.tallas = tallas.inf
            this.tiendas = tiendas
            const c = cookiesHelper.getCookie('token')

            if (c=='') {
                this.$router.push({name:'login'})
            }else{
                this.token = c
                panelService.getInscrito(this.carrera, this.id, this.token).then( (rdo) => {
                    if (rdo.status === 200) {
                        Object.keys(this.persona).forEach( key => {
                            this.persona[key] = rdo.data[key]
                            //eslint-disable-next-line
                            //console.log(key, rdo.data[key])
                        } )
                        this.asignarFecha(this.persona.fnac)
                        this.persona.id = this.id
                        this.isVisible = true
                    } else {
                        cookiesHelper.setCookie('',0)
                        this.$router.push('login')
                    }
                } )
            }
        },
        methods: {
            asignarFecha(fecha) {
                this.currentDate = fecha
                this.viewDate = false
                setTimeout(() => {
                    this.viewDate = true;
                    this.cambiaEdad(moment(this.currentDate))
                }, 100)
            },

            cambiaEdad(data) {
                const today = moment()

                const edad = today.diff(data, 'years')
                const edadCarrera = this.diaCarrera.diff(data, 'years')

                this.edad = edad

                switch (true) {
                    case edadCarrera >=12 && edadCarrera < 14:
                        this.catTemp = { "F": 5 , "V": 6  };
                        break;
                    case edadCarrera >=10 && edadCarrera < 12:
                        this.catTemp = { "F": 7 , "V": 8  };
                        break;
                    case edadCarrera >=8 && edadCarrera < 10:
                        this.catTemp = { "F": 9 , "V": 10  };
                        break;
                    case edadCarrera <=7:
                        this.catTemp = { "F": 11 , "V": 12  };
                        break;
                }

                this.persona.fnac = data.format("YYYY-MM-DD")
                if(this.persona.sexo !== '') this.cambiaSexo()

            },

            cambiaSexo() {
                const idTemp = this.catTemp[this.persona.sexo]
                const seleccionada = this.categorias.find( (c) => parseInt(c.id) === idTemp )

                if(seleccionada.limite < 1) {
                    this.completa = true
                    this.valid = false
                }
                else {
                    this.persona.idCategoria = idTemp.toString()
                    this.completa = false
                    this.valid = true
                }

            },

            cambiaFederado() {

                if(this.persona.federado === 'NO') this.persona.licencia = ''
            },

            actualizar() {
                panelService.updateInfantil(this.persona, this.token).then( res => {

                    if( res.data.success ) {
                        this.resultado = true
                    }
                })
            }
        },
        components: {
            RHeader,
            HeaderPanel,
            datePicker: DatepickerComponent
        }
    }
</script>

<style scoped lang="scss">
    @import "./../../_static/base";
    .contenido {
        width: 90%;
        margin: 0 auto;
    }
    #roscon{
        margin-top: 2rem;
    }
</style>